import {createErrorAction} from './utils';

const TYPES = {
    GET_GAME_XP: 'GET_GAME_XP',
    GET_GAME_XP_COMPLETE: 'GET_GAME_XP_COMPLETE',
    GET_GAME_XP_FAILED: 'GET_GAME_XP_FAILED'
};

export default {
    TYPES,

    getGameXp: payload => ({
        type: TYPES.GET_GAME_XP,
        payload
    }),

    getGameXpSuccess: payload => ({
        type: TYPES.GET_GAME_XP_COMPLETE,
        payload
    }),

    getGameXpFailed: createErrorAction(TYPES.GET_GAME_XP_FAILED)
};
